import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '@telespot/shared/environment';

import { AuthService } from '../services';
import { catchError } from 'rxjs/operators';

export enum ApiAuthErrors {
  UNAUTHORIZED = 'error.unauthorized',
}

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly tokenUrlRegex = /\/v\d\/(files|export|ai|support-files|execute|mosaics|inference|sample|assets)/gi;

  constructor(private readonly auth: AuthService) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.match(this.tokenUrlRegex)) return next.handle(request);

    const authHeaders: Record<string, string> = {
      'X-Api-Key': environment.api.appId,
    };

    if (this.auth.sessionToken) {
      authHeaders['X-Parse-Session-Token'] = this.auth.sessionToken;
    }

    request = request.clone({ setHeaders: authHeaders });

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const isHttpError = error instanceof HttpErrorResponse;
        const isUnauthorized = isHttpError && error.status === 401;

        if (isHttpError && isUnauthorized) return throwError(new Error(ApiAuthErrors.UNAUTHORIZED));

        return throwError(error);
      })
    );
  }
}
